export const adminGetAllEmployeeListQuery = `
query AdminGetAllEmployees($input: AdminSearchEmployeeFilterInput!) {
    adminGetAllEmployees(input: $input) {
        id
        firstName
        lastName
        email
        phoneNumber
        role
        alias
        hiredEmployeeInfo {
            positionLevel
            positions
        }
    }
}
`;

export const getEmployeeByIdQuery = `
query GetEmployeeById($id: ID!) {
    getEmployeeById(id: $id) {
       id
        firstName
        lastName
        email
        phoneNumber
        role
        alias
        hiredEmployeeInfo {
            positions
            positionLevel
            employmentType
            employmentDuration
            dateOfBirth
            hireDate
            rehireDate
            resignDate
            resignReason
            isVerified
            hireStatus
            avatar
            address {
                country
                province
                district
                sector
                cell
                village
            }
        }
        additionalEmployeeInfo {
            linkedInUrl
            portfolioUrl
            githubUrl
            schoolName
            degree
            concentration
        }
    }
}
`;

export const createEmployeeQuery = `
mutation AddEmployee($input: CreateEmployeeInput!) {
    addEmployee(input: $input) {
         id
        firstName
        lastName
        email
        phoneNumber
        role
        alias
        hiredEmployeeInfo {
            positions
            positionLevel
            employmentType
            employmentDuration
            dateOfBirth
            hireDate
            rehireDate
            resignDate
            resignReason
            isVerified
            hireStatus
            avatar
            address {
                country
                province
                district
                sector
                cell
                village
            }
        }
        additionalEmployeeInfo {
            linkedInUrl
            portfolioUrl
            githubUrl
            schoolName
            degree
            concentration
        }
    }
}
`;

export const setEmployeePasswordQuery = `
mutation SetEmployeePassword($input: SetPasswordInput!) {
    setEmployeePassword(input: $input) {
        id
    }
}
`;

export const updateEmployeeQuery = `
mutation AdminUpdateEmployee($input: AdminUpdateEmployeeInput!) {
    adminUpdateEmployee(input: $input) {
       id
        firstName
        lastName
        email
        phoneNumber
        role
        alias
        hiredEmployeeInfo {
            positions
            positionLevel
            employmentType
            employmentDuration
            dateOfBirth
            hireDate
            rehireDate
            resignDate
            resignReason
            isVerified
            hireStatus
            avatar
            address {
                country
                province
                district
                sector
                cell
                village
            }
        }
        additionalEmployeeInfo {
            linkedInUrl
            portfolioUrl
            githubUrl
            schoolName
            degree
            concentration
        }
    }
}
`;
